// extracted by mini-css-extract-plugin
module.exports = {"keys":"Keys_keys__tVH07"};